
import React, { useEffect, useRef } from 'react';

const TelegramLoginButton = ({ onAuth, botName }) => {
  const containerRef = useRef(null);

  useEffect(() => {
    // Clean up any existing script to avoid duplicates
    if (containerRef.current) {
      containerRef.current.innerHTML = '';
    }

    if (!botName) return;

    // Create the script element
    const script = document.createElement('script');
    script.src = 'https://telegram.org/js/telegram-widget.js?22';
    script.setAttribute('data-telegram-login', botName);
    script.setAttribute('data-size', 'large');
    script.setAttribute('data-userpic', 'false'); // userpic often breaks layout or looks weird
    script.setAttribute('data-radius', '8');
    script.setAttribute('data-request-access', 'write');
    script.async = true;

    // Define the global callback function
    window.onTelegramAuth = (user) => {
      if (onAuth) {
        // Transform the user object to match what backend expects (widgetData format)
        // The widget returns { id, first_name, ... hash } directly
        onAuth(user);
      }
    };

    script.setAttribute('data-onauth', 'onTelegramAuth(user)');

    if (containerRef.current) {
      containerRef.current.appendChild(script);
    }

    // Cleanup
    return () => {
      // We don't remove the script on unmount because the widget replaces the script tag with an iframe
      // Re-rendering handles cleanup via innerHTML = ''
      window.onTelegramAuth = undefined;
    };
  }, [botName, onAuth]);

  return <div ref={containerRef} className="flex justify-center" />;
};

export default TelegramLoginButton;
